export const RESET_NOTIFICATION = 'congerocloud/reset_notification';
export const SET_NOTIFICATION = 'congerocloud/set_notification';